@let modalState = state();
<lib-modal
  [show]="modalState.visible"
  [modalTitle]="(modalState.title | translate) ?? ''"
  [contentRef]="modalBody"
  (close)="close()"
  [canCloseWithoutAction]="true"
>
  <ng-template #modalBody>
      <div class="flex justify-center my-[16px]">
        <ng-lottie #lottie [options]="lottieOptions" 
          (animationCreated)="createAnimation($event)" 
          (enterFrame)="enterFrame($event)" 

          [styles]="{ height: '120px', width: '120px' }">
        </ng-lottie>
      </div>

      <p class="content-regular text-foreground-75 leading-[24px] text-center mb-[24px]">
        {{ modalState.message | translate }}
      </p>

      <form
        class="flex flex-col gap-[16px]"
        [formGroup]="form"
        (ngSubmit)="authenticate()"
      >
      <section class="flex flex-col gap-[24px] py-[16px]">
        <lib-input-wrapper
          [label]="'TEMPORARY_AUTH_MODAL.FORM.EMAIL_LABEL' | translate"
          [required]="true"
        >
          @let hasEmailError = form.controls.Email.invalid &&
          form.controls.Email.touched;
          <lib-input
            formControlName="Email"
            [placeholder]="
              'TEMPORARY_AUTH_MODAL.FORM.EMAIL_PLACEHOLDER' | translate
            "
            [state]="hasEmailError ? 'error' : 'default'"
          ></lib-input>
          @if (hasEmailError) {
          <lib-support-message
            [errors]="form.controls.Email.errors"
            [colorClass]="'danger'"
          ></lib-support-message>
          }
        </lib-input-wrapper>

        <lib-input-wrapper
          [label]="'TEMPORARY_AUTH_MODAL.FORM.PASSWORD_LABEL' | translate"
          [required]="true"
        >
          @let hasPasswordError = form.controls.Password.invalid &&
          form.controls.Password.touched;
          <lib-input
            formControlName="Password"
            [type]="showPassword ? 'text' : 'password'"
            [placeholder]="
              'TEMPORARY_AUTH_MODAL.FORM.PASSWORD_PLACEHOLDER' | translate
            "
            [icon]="showPassword ? 'eye' : 'eye-crossed'"
            iconAlign="right"
            [clickableIcon]="true"
            (iconClicked)="showPassword = !showPassword"
            [state]="hasPasswordError ? 'error' : 'default'"
          ></lib-input>
          @if (hasPasswordError) {
          <lib-support-message
            [errors]="form.controls.Password.errors"
            [colorClass]="'danger'"
          ></lib-support-message>
          }
        </lib-input-wrapper>

        @if (modalState.errorMessage) {
        <lib-support-message
          [message]="modalState.errorMessage | translate"
          [colorClass]="'danger'"
        ></lib-support-message>
        }

      </section>

        <div class="flex justify-end gap-[8px] pt-[8px]">
          <lib-button type="secondary" buttonType="button" (click)="close()">
            {{ 'TEMPORARY_AUTH_MODAL.FORM.CANCEL' | translate }}
          </lib-button>
          <lib-button
            type="primary"
            buttonType="submit"
            [loading]="modalState.loading"
          >
            {{ 'TEMPORARY_AUTH_MODAL.FORM.SUBMIT' | translate }}
          </lib-button>
        </div>
      </form>
  </ng-template>
</lib-modal>
